export default __webpack_public_path__ + "static/media/emplacement-1.b8e99f9c.svg";